import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

// Füllt das Kunden-Feld, wenn im Profil-Formular eine Anfrage mit Kunde ausgewählt wird.
// Kontakt-Logik bleibt unverändert (dynamic-select füllt Kontakte bei Kundenauswahl).
export default class extends Controller {
    connect() {
        this.boundSync = this.syncFromRequisition.bind(this);
        this.element.addEventListener('requisition:selected', this.boundSync);
    }

    disconnect() {
        this.element.removeEventListener('requisition:selected', this.boundSync);
    }

    syncFromRequisition(event) {
        const { customer_id } = event.detail || {};
        const customerSelect = this.element.querySelector('select[name*="customer_id"]');
        if (!customerSelect) return;

        if (customer_id != null && customer_id !== '') {
            this.setSelectValue(customerSelect, String(customer_id));
            customerSelect.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
            this.setSelectValue(customerSelect, '');
        }
    }

    setSelectValue(selectEl, value) {
        if (selectEl.tomselect instanceof TomSelect) {
            selectEl.tomselect.setValue(value, true);
        } else {
            selectEl.value = value;
        }
    }
}
